import { useDialog } from "lib/@hooks/useDialog"
import { useState } from "react"
import { Box, DialogContent, DialogTitle } from "@mui/material"
import { AssetTable } from "routes/asset-register/asset-table"
import { assetsFromManyRegisters } from "routes/asset-register/controller/assets-from-many-registers"
import { withBusyMessage } from "lib/graphql/with-busy-message"
import { Done } from "lib/@components/done"
import { PaginationPortal } from "lib/@components/pagination-portal"

export function useAssetViewer(queryParameters, { canEdit = true } = {}) {
    return useDialog(<AssetViewerDialog queryParameters={queryParameters} canEdit={canEdit} />, {
        maxWidth: "lg",
    })
}

function AssetViewerDialog({ queryParameters, canEdit }) {
    const [take] = useState(10)
    const [skip, setSkip] = useState(0)
    const [settings] = useState(() => structuredClone(queryParameters))
    settings.skip = skip
    settings.take = take
    const { items = [], totalCount = 0 } =
        assetsFromManyRegisters.useResults(settings, withBusyMessage("Loading Assets").delay(300)) ?? {}
    if (!queryParameters?.registers?.length) return null
    return (
        <>
            <DialogTitle>{settings.types[0]}</DialogTitle>
            <DialogContent>
                <Box my={1}>
                    <PaginationPortal />
                </Box>
                <AssetTable
                    assets={items}
                    setSkip={setSkip}
                    pageSize={take}
                    register={settings.registers[0]}
                    total={totalCount}
                    canEdit={canEdit}
                />
            </DialogContent>
            <Done />
        </>
    )
}
